import React, { useState, useEffect } from "react";
import {
  Search, Filter, ArrowUpDown, MoreHorizontal, ChevronLeft, ChevronRight
} from "lucide-react";
import api from "../../axios"; // ✅ Axios instance with auth

export default function TransactionHistory() {
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const res = await api.get('/transactions');
      setTransactions(res.data);
    } catch (err) {
      console.error("Failed to fetch transactions", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "success": return "bg-green-100 text-green-800";
      case "pending": return "bg-yellow-100 text-yellow-800";
      case "failed": return "bg-red-100 text-red-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  const filteredTransactions = transactions.filter(tx =>
    tx.reference.toLowerCase().includes(search.toLowerCase()) ||
    tx.project_name.toLowerCase().includes(search.toLowerCase()) ||
    tx.payment_type.toLowerCase().includes(search.toLowerCase()) ||
    tx.channel.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full bg-white rounded-lg shadow-sm mb-20 mt-20" >
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-start sm:items-center">
        <h2 className="text-xl font-semibold text-gray-800">Transaction History</h2>
        <div className="flex space-x-3">
          <div className="relative">
            <Search className="h-4 w-4 absolute top-3 left-3 text-gray-400" />
            <input
              type="text"
              className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Search transactions..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button className="flex items-center space-x-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
            <Filter className="h-4 w-4" />
            <span>Filter</span>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <th className="px-6 py-3">Type</th>
              <th className="px-6 py-3">Amount</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Date</th>
              <th className="px-6 py-3">Reference</th>
              <th className="px-6 py-3">Project</th>
              <th className="px-6 py-3">Channel</th>
              {/* <th className="px-6 py-3 text-right">Actions</th> */}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {loading ? (
              <tr><td colSpan="8" className="px-6 py-6 text-center text-gray-500">Loading...</td></tr>
            ) : filteredTransactions.length === 0 ? (
              <tr><td colSpan="8" className="px-6 py-6 text-center text-gray-500">No transactions found.</td></tr>
            ) : (
              filteredTransactions.map((tx) => (
                <tr key={tx.id} className="hover:bg-gray-50">

                    <td className="px-6 py-4 text-sm font-semibold text-gray-900">
                    {tx.payment_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </td>
                  <td className="px-6 py-4 text-sm font-semibold text-gray-900">₦{tx.amount.toLocaleString()}</td>
                  <td className="px-6 py-4">
                  <span className={`px-3 py-1 inline-flex text-xs font-semibold rounded-full ${getStatusBadgeClass(tx.status)}`}>
                    {tx.status === 'success' ? 'Completed'
                    : tx.status === 'pending' ? 'Pending'
                    : tx.status === 'failed' ? 'Failed'
                    : tx.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">{formatDate(tx.paid_at)}</td>
                  <td className="px-6 py-4 text-sm text-gray-700">{tx.reference}</td>
                  <td className="px-6 py-4 text-sm">
                    <div className="text-gray-900">{tx.project_name}</div>
                    <div className="text-xs text-gray-500">{tx.project_id}</div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">{tx.channel}</td>
                  {/* <td className="px-6 py-4 text-right">
                    <button className="text-gray-400 hover:text-gray-600">
                      <MoreHorizontal className="h-5 w-5" />
                    </button>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
